
/* eslint-disable react-hooks/rules-of-hooks */ 
import $ from 'jquery';
import * as React from "react";
import {
    makeStyles,
    shorthands,
    Button,
    Caption1,
    tokens,
    Checkbox,
    CompoundButton,
    Text,
    Body1,
    Body1Strong,
    Body1Stronger,
    Body2,
    Caption1Strong,
    Caption1Stronger,
    Caption2,
    Caption2Strong,
    Display,
    LargeTitle,
    Subtitle1,
    Subtitle2,
    Subtitle2Stronger,
    Title1,
    Title2,
    Title3,
    Badge,
    mergeClasses,
    Image
} from "@fluentui/react-components"; 

import {
    AlertUrgent16Filled,
    Attach16Regular,
    CheckmarkCircle16Regular,
    CircleHalfFill16Regular,
    Comment16Regular,
    MoreHorizontal20Regular,
    CalendarMail16Regular, ArrowReplyRegular, ShareRegular
} from "@fluentui/react-icons";
import { Card, CardHeader, CardFooter, CardPreview } from "@fluentui/react-components"; 

import Lightbox from "./Lightbox";
//import Image from "./Image";


import Container from 'react-bootstrap/Container'; 
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Stack from 'react-bootstrap/Stack';
import ThemeProvider from 'react-bootstrap/ThemeProvider'

import { useMediaQuery } from 'react-responsive'

//import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
//import { Doughnut } from 'react-chartjs-2';
//ChartJS.register(ArcElement, Tooltip, Legend);



const resolveAsset = (asset: string) => {
    const ASSET_URL =
        "https://raw.githubusercontent.com/microsoft/fluentui/master/packages/react-components/react-card/stories/assets/";

    return `${ASSET_URL}${asset}`;
};
const onSelected1Change = () => {
};

const flex = {
    ...shorthands.gap("16px"),
    display: "flex"
}

function useStyles() {
    return { 

        main: {
            ...flex,
            flexDirection: "column"
        },

        row: {
            ...flex,
            flexWrap: "wrap",
            //rowGap: "10px" 
            width: "100vw",
        },

        card: {
            width: "300px",
            maxWidth: "100%",
            height: "fit-content"
        },

        cardPreview: {
            //height: "100%",
            width: "100%",
            maxWidth: "100%",
            //height: "fit-content",
            //display: flex,
            //alignItems:"center",
        },



        horizontalCardImage: {
            width: "64px",
            minWidth: "64px",
            height: "64px",
            minHeight: "64px",
        },

        headerImage: {
            ...shorthands.borderRadius("4px"),
            maxWidth: "44px",
            maxHeight: "44px",
        },  



        card2: {
            width: "1000px",
            maxWidth: "100%",
            height: "fit-content"
        },

        caption: {
            color: tokens.colorNeutralForeground3
        },

        smallRadius: {
            ...shorthands.borderRadius(tokens.borderRadiusSmall)
        },

        grayBackground: {
            backgroundColor: tokens.colorNeutralBackground3
        },

        logoBadge: {
            ...shorthands.padding("5px"),
            ...shorthands.borderRadius(tokens.borderRadiusSmall),
            backgroundColor: "#FFF",
            boxShadow:
                "0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)"
        },

        actions: {
            display: "flex"
        },

        container: { 
            columnGap: '16px',
            display: "flex",
            flexWrap: "wrap-reverse",  
            flexWrap: "nowrap",   
            justifyContent: "space-evenly",
            alignItems: "center",
            transition: "all .67s ease-in -out",   
            height: 'calc(-150px + 100vh)',
        },
 
        card1: {  
            padding: '20px',
            //height: 'calc(-284px + 100vh)',   //this is only for mobile
            //maxHeight: 'calc(-284px + 100vh)',   //this is only for mobile
            height: 'calc(-178px + 100vh)',
            maxHeight: 'calc(-178px + 100vh)', 
            flexGrow: 0,
            flexShrink: 0, 
        },

        containerListMobile: {  
            padding: '8px 20px 8px 20px',
            height: '98px',
            maxHeight: '98px', 
            maxWidth: '100%', 
            flexGrow: 1, 
        },
        gridMobile: {
            ...shorthands.gap("16px"),
            display: "flex",
            flexDirection: "row",
            marginTop: "3px",
            overflowX: 'auto',
            height: '100%'
        }, 
        cardCaseStudyMobile: {
            minWidth: "316px",
            maxWidth: "316px",
            maxHeight: "70px",
            minHeight: "70px",
            cursor: 'pointer'
        },
        titleCaseStudyMobile: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            maxWidth: "250px",
            paddingRight: "18px"
        },

        containerPreview: { 
            margin: '0px', 
            padding: '24px',
            height: 'calc(-178px + 100vh)',
            maxHeight: 'calc(-178px + 100vh)',  
            maxWidth: '100%', 
            flexGrow: 1,
        }, 

        cardCaseStudy: {
            maxWidth: "380px",
            width: "380px", 
            maxHeight: "162px",
            minHeight: "162px",
            cursor: 'pointer'
        },
        pCaseStudy: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "3",
            WebkitBoxOrient: "vertical",
            marginBottom: "8px"
        },
        titleCaseStudy: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            paddingRight: "18px"
        },


        display4: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical", 
        },

        flex: {
            ...shorthands.gap("4px"),
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
        },

        labels: {
            ...shorthands.gap("6px"),
        },

        footer: {
            ...shorthands.gap("12px"),
            display: "flex !important",
        },

        taskCheckbox: {
            display: "flex",
            alignItems: "flex-start",
        },

        grid: {
            ...shorthands.gap("16px"),
            display: "flex",
            flexDirection: "column",
            marginTop: "3px",  
            overflowY: 'auto',
            overflowX: 'hidden',
        },

    }
}

//Images!
const excelLogo = resolveAsset("xlsx.png");
const wordLogo = resolveAsset("docx.png");
const powerpointLogoURL = resolveAsset("pptx.png");
const pdfURL = resolveAsset("pdf.png");



//Case Study Cards Loaded from this Array!!!
let Apps = [
    {
        index: 0,
        private: false,
        header: "Front End Web Design with Dark Mode - HTML5, CSS3 & Bootstrap5",
        company: "Audible",
        caption: "JavaScript &gt; Front-end Design",
        description: "Created a Front End design using HTML5+CSS3, utilizing Bootstrap 5 to provide a responsive experience for both desktop and mobile with the ability to toggle between light and dark mode.",
        MainAppHTML: <iframe id="MainAppHTML" src="https://audible-av-broadcast-fe.azurewebsites.net/" title="....!"></iframe>,
        image: {
            as: "img",
            src: powerpointLogoURL,
            alt: "PowerPoint app logo",
        },
    },
    {
        index: 1,
        private: false,
        header: "Find My Shoe Size Fit Web App - ASP.NET Core 6.0 with React",
        company: "Antonia Saint NY",
        caption: "React &gt; Front-end Design",
        description: "We were contacted by our client Antonia Saint NY to design and publish a Web App to ergonomically collect their customers footwear information. They are a NYC based manufacturing organization that provide custom sized modern footwear.",
        MainAppHTML: <iframe id="MainAppHTML" src="https://asnywebapp-formfit-react.azurewebsites.net/" title="....!"></iframe>,
        image: {
            as: "img",
            src: excelLogo,
            alt: "excelLogo app logo",
        },
    }, 
    {
        index: 2,
        private: false,
        header: "Excel VBA Modern UI Dashboard - Displays Total Pitches & Swings Statistics Using Live Custom Charting With a Dark Theme",
        company: "Medtronic",
        caption: "JavaScript &gt; Front-end Design",
        description: "Created a solution entirely within excel VBA to import raw acceleration sensor data from Athlete testing. The script calculates and display total pitches, swings & other metrics using custom charting (bar, dial indicators, etc.) with a dark theme UI.",
        MainAppHTML: 
            <Image 
            alt="Medtronic"
            shape="rounded"
            src="https://media.licdn.com/dms/image/C4E2DAQHTHi3eEMH63A/profile-treasury-image-shrink_1280_1280/0/1679681249175?e=1702656000&v=beta&t=EG8-V2DsMzbnff4aIHYhK90nPd0DZzYGAzxUNTbEsBI"
            fit="contain"
            /> 
        ,
        image: {
            as: "img",
            src: excelLogo,
            alt: "Excel app logo",
        },
    }, 
    {
        index: 3,
        private: false,
        header: "NodeJS WebScrapping using Puppeteer and Microsoft SQL Server",
        company: "Global Grid Telecom",
        caption: "JavaScript &gt; Front-end Design",
        description: "Created a Node JS console application to web scrape some well known video game & movie quotes from a 3rd party website. I use #puppeteer to create a headless instance of chromium to grab our #HTML, #cheerio to parse, #mssql to store, using async-await to handle the asynchronous promises.",
        MainAppHTML: <Lightbox url="/LinkedIn/CaseStudy_NodeJS_Puppeteer_WebScraping.pdf" />,
        image: {
            as: "img",
            src: powerpointLogoURL,
            alt: "PDF logo",
        },
    },
    { 
        private: false,
        header: "JMP JSL / Microsoft SQL - Dynamic IR Charting with Cp / Cpk Analysis",
        company: "Saint Gobain Abrasives",
        caption: "JavaScript &gt; Front-end Design",
        description: "Designed a JMP JSL script that includes an initial GUI to specify reporting parameters, generate a custom JMP report and save the report as a PDF. We imported our client's manufacturing production metrics and limits from several Microsoft SQL tables, create a report of individual run charts with spec and control limits that include distribution charts with capability analysis (Cp & Cpk) to determine if the process is statistically capable of meeting the respective specification limits. This project automated costly manual data formatting and provided a process to investigate special cause variation in my clients manufacturing process.",
        MainAppHTML:
            <Image
                alt="JMP JSL script"
                shape="rounded"
                src="https://media.licdn.com/dms/image/D562DAQGmqXO8Rsf81Q/profile-treasury-image-shrink_800_800/0/1680816076189?e=1702681200&v=beta&t=rvyr5pBkyzPnv6COfJ_LmGjDq0KCdWIUeIgjoqZfieA"
                fit="contain"
            />,
        //MainAppHTML: <Lightbox url="/LinkedIn/CaseStudy_JMP_GUI_ReportGeneratorWithPDF.pdf" />,
        image: {
            as: "img",
            src: wordLogo,
            alt: "wordLogo app logo",
        },
    },
    {
        index: 33,
        private: false,
        header: "LabVIEW KEPServer OPC Server Datalogger",
        company: "Wash Univ.in St.Louis",
        caption: "JavaScript &gt; Front-end Design",
        description: "We were contacted by our client to develop a multi channel real time data charting & logging application in LabVIEW. The application monitors and records all of the channels/tags from their R&D Allen Bradley PLC via a KEPServer OPC Server using the DataSocket Library. The LabVIEW Datalogger uses the DataSocket API which is included with the base version of LabVIEW to read data from the KEPServer OPC Server, all tag URLs are soft-coded by the CSV file.",
        MainAppHTML: <Lightbox url="/LinkedIn/Documentation_LabVIEW OPC DL_7-3-2018.pdf" />,
        image: {
            as: "img",
            src: wordLogo,
            alt: "wordLogo app logo",
        },
    },
    {
        index: 3,
        private: false,
        header: "LabVIEW Interface and PID Controller Design",
        company: "Wash Univ. in St. Louis",
        caption: "JavaScript &gt; Front-end Design",
        description: "Our client's research facility has hundreds of data acquisition points and dozens of control valves. They provided us with a non-functioning LabVIEW project that controlled their National Instruments PXI real-time chassis. They requested that we improve their existing LabVIEW operational interface and design 4 closed loop PID controllers for their pressurized quench tank research application.",
        MainAppHTML:
            <Image
                alt="JMP JSL script"
                shape="rounded"
                src="https://media.licdn.com/dms/image/C4E2DAQHyziSaGIk1aQ/profile-treasury-image-shrink_800_800/0/1680110903455?e=1702681200&v=beta&t=BikGBLKneisSXE9PiLb8mNADi67RP-v9cBrTA04ykeI"
                fit="contain"
            />,
        image: {
            as: "img",
            src: wordLogo,
            alt: "wordLogo app logo",
        },
    },
    {
        index: 4,
        private: false,
        header: "Find My Shoe Size Fit Web App - ASP.NET by VB using Microsoft SQL Azure hosted by Azure Services",
        company: "Antonia Saint NY",
        caption: "JavaScript &gt; Front-end Design",
        description: "We were contacted by our client Antonia Saint NY to design and publish a Web App to ergonomically collect their customers footwear information. They are a NYC based manufacturing organization that provide custom sized modern footwear. I designed a ASP.NET by VB Web App hosted on Microsoft Azure to provide the ability for our client�s customers to submit their sizes through their website. The web app is a series of jQuery responsive flexboxes to ergonomically prompts users for their footwear information using dropdowns, card selections and textboxes. We created a SQL Table in their existing Azure Cloud SQL Database as a backend for the web app that stores the customers submissions. The table is designed to handle multiple entries from the same user, the date of submission is stored along with other record storage metrics. ",
        MainAppHTML: <iframe id="MainAppHTML" src="https://asnywebapp-formfit.azurewebsites.net/" title="....!"></iframe>,
        image: {
            as: "img",
            src: excelLogo,
            alt: "excelLogo app logo",
        },
    },
    {
        index: 5,
        private: false,
        header: "JMP DOE Technical Report - Gaussian Model",
        company: "Linus G.",
        caption: "JavaScript &gt; Front-end Design",
        description: "My client has a commercial simulator that requires several minutes - hours to run, described as a typical expensive black box function with 5 factors (Well placement x/y, Perforation, CO2 Injection Rate, etc.) They reached out for us to tutor them in 'simple plain language' all DoE related statistics terms and how to analyze them. The goal of this experiment is to describe the non- linear behavior and maximize the response variable(NPV) as a function of the 5 factors above while minimizing the number of runs.The empirical data is deterministic and expected to be non - linear, thus a definitive screening design was used to efficiently distinguish between important and significant factors and identifying local maximums.After eliminating 2 non - significant factors(CO2 & BHP) and identifying 2 local maximums an augmented Latin Hypercube space filling experiment was designed to efficiently investigate the remaining system response.The results yielded a statistically significant Gaussian Process Model estimating a global maximum NPV value of XXXX at(XX, YY, ZZ) < X, Y, Perforation >.",
        MainAppHTML: <Lightbox url="/LinkedIn/Report_3-27_RBILLC.pdf" />,
        image: {
            as: "img",
            src: wordLogo,
            alt: "wordLogo app logo",
        },
    }
]
  
const IsDesktop = () => {
    console.log(useMediaQuery({ minWidth: 768 })); 
    return useMediaQuery({ minWidth: 768 });
} 
export { IsDesktop };
     
const CardCaseStudy = ({ index, image, header, description, company, ...props }) => {
    const styles = useStyles();
     
    // Case Study Card 
    return ( 
        <Card
            {...props}
            size="medium"
            style={styles.cardCaseStudy}
        >
            <CardHeader
                image={image}
                header={<Text weight="semibold" style={styles.titleCaseStudy}>{header}</Text>}
                description={
                    <Caption1 className={styles.caption}>{company}</Caption1>
                } 
            />
             
            <p style={styles.pCaseStudy}>
                {description}
            </p>
        </Card> 
    ); 
}; 

class CardsCaseStudy extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}; 
    }
      
    render() { 
        //Dyanmically Load the Cards
        return Apps.map((App, index) => {
            //Return the Case Study Card
            return <CardCaseStudy
                index={index}
                selected={(this.props.cardAppSelected == index ? true : false)}
                floatingAction={
                    <Checkbox checked={(this.props.cardAppSelected == index ? true : false)} />
                }
                image={App.image}
                header={App.header}
                description={App.description}
                company={App.company}
                onSelectionChange={(_, selected) => {
                      
                    // Update the Parent State Variable
                    this.props.callbackFromParent(index); 

                }}
            />;
        });
    } 
};
 
const CardCaseStudyMobile = ({ index, image, header, description, company, ...props }) => {
    const styles = useStyles();
     
    // Case Study Card Mobile
    return (  
        <Card 
            style={styles.cardCaseStudyMobile}
            orientation="horizontal"
            {...props}
        >
            <CardPreview className={styles.horizontalCardImage}>
                <img
                    className={styles.horizontalCardImage}
                    src={image.src}
                    alt={image.alt}
                />
            </CardPreview> 
            <CardHeader
                header={<Text style={styles.titleCaseStudyMobile} weight="semibold">{header}</Text>}
                description={
                    <Caption1 className={styles.caption}>{company}</Caption1>
                } 
            />
        </Card> 
    ); 
}; 

class CardsCaseStudyMobile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}; 
    }
     
    render() {
        //Dyanmically Load the Cards
        return Apps.map((App, index) => {

            //Return the Case Study Card
            return <CardCaseStudyMobile
                index={index}
                selected={(this.props.cardAppSelected == index ? true : false)}
                floatingAction={
                    <Checkbox checked={(this.props.cardAppSelected == index ? true : false)} />
                }
                image={App.image}
                header={App.header}
                description={App.description}
                company={App.company}
                onSelectionChange={(_, selected) => {
                      
                    // Update the Parent State Variable
                    this.props.callbackFromParent(index); 

                }}
            />;
        });
    } 
};




//NOT WORKING
//class MainApp2 extends React.Component {
//    constructor(props) {
//        super(props);
//        this.state = {};
//    }

//    render() {
//        return Apps.filter(function (el, index) {
//            return index == this.props.state.cardAppSelected;
//        })[0].MainAppHTML;
//    }
//};


const Logo = ({ width, height }) => {
    // Return the HTML  
    return (
        <div id="logoContainer">
            <svg id="svg3827" version="1.1" width={width} height={height} viewBox="0 0 393 393">
            <path id="path4271" d="m 7.4154636,391.60035 c -1.69665,-0.7387 -4.05915,-2.5818 -5.25,-4.0957 -2.16502996661,-2.7524 -2.16518996661,-2.7571 -2.16518996661,-62.1178 V 266.02174 H 10.000274 h 10 v 53.00001 53 h 176.499996 176.5 v -53 -53.00001 h 10 10 v 59.36511 59.3652 l -2.1679,2.756 c -4.6044,5.8536 7.3537,5.5171 -194.54998,5.4746 -153.232906,-0.032 -186.3225764,-0.2745 -188.8669264,-1.3823 z" style={{fill: '#FDFDFD'}} />
            <path id="path4269" d="m 35.000274,322.02175 v -3 h 161.499996 161.5 v 3 3 h -161.5 -161.499996 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4267" d="m 187.20785,297.17124 c -0.71083,-0.451 -1.61083,-2.0093 -2,-3.4628 -0.5301,-1.98 -5.81597,-6.2732 -21.07403,-17.1165 -17.19214,-12.2178 -20.79037,-14.3888 -23.08631,-13.9296 -4.64323,0.9286 -7.38073,-3.2804 -5.01206,-7.7063 1.97397,-3.6884 8.94535,-1.4463 8.97713,2.8871 0.008,1.0397 7.82344,7.1923 20.53594,16.1657 17.37385,12.2637 21.09362,14.4924 24.23769,14.5223 3.26439,0.031 6.15717,-1.8123 23.89294,-15.225 14.3511,-10.8532 20.27162,-15.9137 20.5,-17.5224 0.27919,-1.9666 0.9087,-2.262 4.82112,-2.262 3.82669,0 4.54537,0.318 4.80322,2.1254 0.4126,2.892 -2.38091,5.4385 -5.68947,5.1864 -2.12819,-0.1621 -7.14116,3.1439 -22.91887,15.1147 -13.13642,9.9668 -20.19488,15.9527 -20.19488,17.1264 0,3.7065 -4.5975,6.1234 -7.79242,4.0966 z" style={{fill: '#FDFDFD'}} />
            <path id="path4265" d="m 2.7363339e-4,229.02174 v -17 H 4.5002736 h 4.5 v 17 17 h -4.5 -4.49999996661 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4263" d="m 13.000274,228.88484 v -17.1369 l 6.5537,0.526 c 7.80432,0.6265 16.88276,4.7391 23.69182,10.7327 2.50876,2.2083 4.86538,4.0151 5.23693,4.0151 0.37156,0 0.52751,-3.376 0.34655,-7.5023 l -0.329,-7.5024 h 4.5 l 4.5,0.001 -0.29559,17.0013 -0.2956,17.0013 h -3.35016 c -2.91676,0 -3.75706,-0.6341 -6.49551,-4.9016 -4.07259,-6.3466 -11.97325,-13.7012 -17.33122,-16.1334 -7.72246,-3.5045 -7.73192,-3.4928 -7.73192,9.5361 v 11.5 h -4.5 -4.5 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path style={{fill: '#FDFDFD', fillOpacity: 1}} d="M 62 212 L 62 229 L 62 246 L 83 246 L 104 246 L 104 231.6875 L 104 217.375 L 101.19531 214.6875 L 98.390625 212 L 80.195312 212 L 62 212 z M 71 219 L 81.345703 219 C 94.546923 219 95 219.39253 95 230.82812 L 95 239 L 83 239 L 71 239 L 71 229 L 71 219 z " transform="translate(0,0.02173984)" id="path4261" />
            <path id="path4257" d="m 110.63663,243.38534 c -2.60376,-2.6037 -2.63636,-2.814 -2.63636,-17 v -14.3636 h 4.5 4.5 v 11.9286 c 0,15.3398 -0.24172,15.0714 13.57143,15.0714 h 10.42857 v -13.5 -13.5 h 4.5 4.5 v 17 17 H 131.63663 113.273 Z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4255" d="m 154.00027,242.54534 v -3.4764 l 17.25,-0.2736 17.25,-0.2736 v -2.5 -2.5 l -17.35677,-0.2741 -17.35678,-0.274 0.68494,-3.6511 c 1.1863,-6.3235 3.61862,-11.1726 7.16689,-14.2881 l 3.43131,-3.0127 h 15.02856 15.02857 l -0.31336,3.25 -0.31336,3.25 -12.91249,0.2811 c -13.58624,0.2957 -15.47375,0.9593 -15.55571,5.4689 -0.0288,1.5847 1.28832,1.75 13.94515,1.75 h 13.97694 l 1.77306,2.706 c 1.04656,1.5973 1.77305,4.5859 1.77305,7.294 0,2.7081 -0.72649,5.6967 -1.77305,7.294 l -1.77306,2.706 h -19.97694 -19.97695 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4253" d="m 214.00027,232.52174 v -13.5 h -6 -6 v -3.5 -3.5 h 17 17 v 3.5 3.5 h -6.5 -6.5 v 13.5 13.5 h -4.5 -4.5 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path style={{fill: '#FDFDFD', fillOpacity: 1}} d="M 240 211.86328 L 240 228.93164 L 240 246 L 244.5 246 L 249 246 L 249 239.5 L 249 233 L 258.04492 233 C 266.24382 233 267.31472 233.22297 269.47656 235.38477 C 270.78833 236.69657 272.35932 239.62157 272.96875 241.88477 L 274.07812 246 L 279.05859 246 C 283.97894 246 284.03082 245.9668 283.4043 243.25 C 283.05551 241.7375 281.46834 238.1375 279.87695 235.25 L 276.98242 230 L 280.39844 230 L 283.8125 230 L 282.6875 226.33008 C 282.06814 224.31208 279.45877 220.37458 276.89062 217.58008 L 272.22266 212.5 L 256.11133 212.18164 L 240 211.86328 z M 249 219 L 257.8457 219 C 265.14461 219 266.98001 219.31913 268.3457 220.82812 C 269.25595 221.83392 270 223.40893 270 224.32812 C 270 225.78372 268.64488 226 259.5 226 L 249 226 L 249 222.5 L 249 219 z " transform="translate(0,0.02173984)" id="path4251" />
            <path id="path4247" d="m 288.00027,229.02174 v -17 h 4.5 4.5 v 17 17 h -4.5 -4.5 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4245" d="m 301.39207,242.77174 c 0.353,-1.7875 1.9657,-5.3875 3.5837,-8 l 2.9419,-4.75 h -3.4587 c -1.9023,0 -3.4587,-0.465 -3.4587,-1.0332 0,-2.9427 5.4907,-11.3098 9.1716,-13.9762 l 4.1285,-2.9906 h 14.8499 14.85 v 3.5 3.5 h -12.9433 c -12.2416,0 -13.0277,0.1205 -14.5,2.2225 -3.1395,4.4823 -2.4326,4.7775 11.4433,4.7775 h 13 v 3.5 3.5 h -11.9433 c -11.2082,0 -12.0391,0.1368 -13.5,2.2225 -0.8562,1.2224 -1.5567,2.5724 -1.5567,3 0,0.4276 6.975,0.7775 15.5,0.7775 h 15.5 v 3.5 3.5 h -22.125 -22.125 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4243" d="m 349.00027,242.54594 v -3.4758 l 16.75,-0.2742 16.75,-0.2742 0.3164,-2.75 0.3164,-2.75 h -17.198 -17.1981 l 0.5342,-3.983 c 0.8044,-5.9972 4.4488,-12.6807 8.1681,-14.9793 2.9102,-1.7986 4.9553,-2.0377 17.429,-2.0377 h 14.132 v 3.5 3.5 h -12.9743 -12.9743 l -1.4858,2.8732 c -0.8172,1.5803 -1.2038,3.1553 -0.8591,3.5 0.3448,0.3447 6.8403,0.6268 14.4345,0.6268 h 13.8076 l 1.5257,2.9503 c 2.2269,4.3064 1.9646,11.2221 -0.5469,14.4148 l -2.0726,2.6349 h -19.4274 -19.4274 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4241" d="m 0.06117363,172.44224 -0.0596,-14.5794 12.93670037,0.3294 c 12.81455,0.3264 12.96648,0.3578 16.09094,3.3295 6.03915,5.7438 9.04104,14.5 4.97107,14.5 -1.1,0 -2,0.1299 -2,0.2886 0,0.1587 0.9,2.0538 2,4.2114 2.87038,5.6301 2.6209,6.5 -1.86414,6.5 -3.65991,0 -3.95521,-0.2385 -5.58707,-4.5114 -2.06478,-5.4065 -3.81296,-6.4886 -10.48306,-6.4886 -4.96193,0 -5.06574,-0.0615 -5.06574,-3 v -3 h 7 c 3.85,0 7,-0.3499 7,-0.7775 0,-0.4276 -0.70052,-1.7776 -1.5567,-3 -1.3545,-1.9338 -2.45862,-2.2225 -8.5,-2.2225 H 8.0002736 v 11.5 11.5 h -3.93975 -3.93973997 l -0.0596,-14.5795 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path style={{fill: '#FDFDFD', fillOpacity: 1}} d="M 60.611328 158 C 39.966238 158 40.613799 157.48016 40.167969 174.41016 L 39.837891 187 L 55.603516 187 C 76.532685 187 76 187.43637 76 170.32617 L 76 158 L 60.611328 158 z M 59.611328 164 L 68.082031 164 L 67.791016 172.25 L 67.5 180.5 L 57.75 180.78711 L 48 181.07227 L 48 174.10742 C 48 164.68172 48.782848 164 59.611328 164 z " transform="translate(0,0.02173984)" id="path4239" />
            <path id="path4235" d="m 90.000274,175.52174 v -11.5 h -5 c -4.88889,0 -5,-0.067 -5,-3 v -3 h 14 13.999996 v 3 c 0,2.9333 -0.11111,3 -5,3 h -4.999996 v 11.5 11.5 h -4 -4 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4233" d="m 112.00027,172.46134 v -14.5603 l 3.75,0.3103 3.75,0.3104 0.2999,5.75 0.29991,5.75 h 9.95009 9.9501 v -6 -6 h 4 4 v 14.5 14.5 h -4 -4 v -5.5 -5.5 h -10 -10 v 5.5 5.5 h -4 -4 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4231" d="m 152.63386,182.58364 c 0.83171,-2.4409 2.1544,-4.971 2.9393,-5.6224 2.14605,-1.7811 1.72322,-2.9395 -1.07289,-2.9395 -3.36246,0 -3.25373,-2.4199 0.36513,-8.1263 4.21138,-6.6406 7.58402,-7.8737 21.536,-7.8737 h 11.59887 v 3 3 h -10.5 c -9.16667,0 -10.75397,0.254 -12.5,2 -1.1,1.1 -2,2.45 -2,3 0,0.6061 4.33333,1 11,1 h 11 v 3 3 h -9.5 c -8.51852,0 -9.73246,0.2325 -11.75,2.25 l -2.25,2.25 13.5,0.5 13.5,0.5 0.31642,2.75 0.31642,2.75 h -19.00572 -19.00572 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path id="path4229" d="m 193.00027,172.38244 v -14.6393 l 4.94975,0.5862 c 6.18044,0.732 14.33209,4.5299 19.83752,9.2423 l 4.21273,3.6059 v -6.6382 -6.6383 l 3.75,0.3103 3.75,0.3104 0.27746,14.25 0.27745,14.25 h -3.42321 c -2.99174,0 -3.8093,-0.6017 -6.48641,-4.7736 -4.99115,-7.778 -13.0899,-14.2147 -17.89529,-14.2227 -2.1757,0 -2.25,0.31 -2.25,9.4963 v 9.5 h -3.5 -3.5 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path style={{fill: '#FDFDFD', fillOpacity: 1}} d="M 233 158 L 233 172.5 L 233 187 L 251.45508 187 L 269.91211 187 L 268.52539 183.07031 C 267.76285 180.90901 266.3814 177.98401 265.45508 176.57031 C 263.7943 174.03581 263.80616 174 266.38477 174 C 269.86988 174 269.79765 171.64885 266.13477 165.87305 C 261.92339 159.23245 258.55159 158 244.59961 158 L 233 158 z M 241 164 L 247.8457 164 C 254.67772 164 256.0573 164.621 258.40625 168.75 C 258.95259 169.7103 257.0184 170 250.05859 170 L 241 170 L 241 167 L 241 164 z M 248.3457 176 C 254.19144 176 256.02853 176.37274 257.3457 177.82812 C 258.25595 178.83392 259 179.95894 259 180.32812 C 259 180.69732 254.95 181 250 181 C 241.0667 181 241 180.9815 241 178.5 C 241 176.06 241.17769 176 248.3457 176 z " transform="translate(0,0.02173984)" id="path4227" />
            <path id="path4221" d="m 274.20524,183.77174 c 0.60551,-1.7875 1.93211,-4.4445 2.94798,-5.9044 2.4033,-3.4537 2.33676,-3.8456 -0.65295,-3.8456 -3.41362,0 -3.25198,-2.5218 0.52737,-8.2276 4.39316,-6.6325 7.52792,-7.7724 21.37373,-7.7724 h 11.5989 v 3 3 h -10.5 c -9.1667,0 -10.754,0.254 -12.5,2 -1.1,1.1 -2,2.45 -2,3 0,0.6061 4.3333,1 11,1 h 11 v 3 3 h -9.461 c -8.5225,0 -9.6694,0.2232 -11.56131,2.25 l -2.10021,2.25 13.31122,0.5 13.3113,0.5 0.3164,2.75 0.3164,2.75 h -19.0144 -19.01436 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path style={{fill: '#FDFDFD', fillOpacity: 1}} d="M 315 158 L 315 172.5 L 315 187 L 318.44727 187 L 321.89648 187 L 322.19727 181.75 L 322.5 176.5 L 329.75781 176.20508 C 336.44691 175.93418 337.19947 176.1127 339.38477 178.4707 C 340.68867 179.8777 342.02512 182.37147 342.35352 184.01367 C 342.89772 186.73457 343.30661 187 346.97461 187 C 351.85891 187 352.14128 185.53854 348.48828 179.14844 C 347.11988 176.75484 346 174.61734 346 174.39844 C 346 174.17964 347.17478 174 348.60938 174 C 350.95107 174 351.14782 173.7188 350.54492 171.25 C 349.48652 166.9159 345.13767 161.29392 341.51367 159.57422 C 339.08927 158.42382 335.07931 158 326.59961 158 L 315 158 z M 331.85156 164.17188 C 337.26352 164.29771 340 165.79961 340 168.6543 C 340 169.6821 337.86159 170 330.93359 170 L 321.86719 170 L 322.18359 167.25 C 322.49059 164.5816 322.70319 164.49067 329.36719 164.20117 C 330.24931 164.16285 331.07843 164.1539 331.85156 164.17188 z " transform="translate(0,0.02173984)" id="path4219" />
            <path id="path4215" d="m 357.07287,184.38684 c -1.7763,-2.2582 -2.0726,-4.0347 -2.0726,-12.4274 0,-9.388 0.1089,-9.8782 2.6349,-11.8651 2.3972,-1.8857 3.9755,-2.0726 17.5,-2.0726 h 14.8651 v 3 3 h -12.3776 c -9.4311,0 -12.6561,0.3356 -13.5477,1.41 -0.7154,0.862 -1.0545,4.0681 -0.8724,8.25 l 0.2977,6.84 9.9118,0.2882 c 10.205,0.2967 12.1175,-0.2453 11.014,-3.121 -0.5049,-1.3157 -1.9876,-1.6672 -7.0328,-1.6672 h -6.393 v -3 -3 h 8.9433 c 8.1081,0 9.0887,0.2075 10.5,2.2225 2.022,2.8868 1.9921,9.1833 -0.058,12.3127 -1.5962,2.4361 -1.7874,2.4648 -16.4274,2.4648 -14.811,0 -14.8126,-2e-4 -16.885,-2.6349 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            <path style={{fill: '#FDFDFD'}} d="M 90.714844 39.980469 C 88.014668 40.110782 85.749166 42.851099 86.453125 46.603516 C 86.945225 49.226646 86.245711 51.546292 83.025391 57.951172 L 78.978516 66 L 56.988281 66 L 35 66 L 35 69 L 35 72 L 55.607422 72 C 71.693962 72 76.104601 72.27421 75.712891 73.25 C 75.436911 73.9375 67.904849 89.877787 58.974609 108.67383 C 45.47959 137.07771 42.340576 142.94865 40.384766 143.43945 C 37.957746 144.04865 36.237187 147.95599 37.498047 149.99609 C 37.876807 150.60889 40.045667 150.97003 42.341797 150.80273 L 46.5 150.5 L 46.3125 146.5 C 46.15618 143.1817 48.97391 136.5355 62.849609 107.5 L 79.576172 72.5 L 87.537109 72.21875 L 95.5 71.939453 L 104.4707 111.08594 C 112.65194 146.78869 114.4915 152.84248 116.5332 150.80078 C 116.77841 150.55558 112.93221 132.94885 107.98828 111.67383 C 103.04435 90.398767 99 72.768764 99 72.496094 C 99 72.223414 157.275 72 228.5 72 L 358 72 L 358 69 L 358 66 L 227.64453 66 L 97.289062 66 L 95.574219 58.064453 C 94.302879 52.180353 94.136368 49.613179 94.929688 48.130859 C 96.415757 45.354099 96.268737 43.411316 94.429688 41.572266 C 93.260178 40.402756 91.942196 39.921236 90.714844 39.980469 z M 90.328125 50.5 L 91.492188 55 C 92.133117 57.475 92.949258 60.9625 93.304688 62.75 L 93.951172 66 L 88.474609 66 C 85.463359 66 83 65.763339 83 65.474609 C 83 65.185879 84.649173 61.698379 86.664062 57.724609 L 90.328125 50.5 z " transform="translate(0,0.02173984)" id="path4213" />
            <path id="path4209" d="m 284.39049,143.14154 c 2.40828,-5.7103 3.06268,-8.3461 2.37638,-9.5724 -1.34898,-2.4105 -0.1145,-6.3022 2.2357,-7.0481 2.7657,-0.8778 5.7833,0.2499 6.4716,2.4185 0.4439,1.3986 4.647,2.9061 18.3012,6.5639 18.209,4.8781 19.8784,5.1535 24.3171,4.0121 4.7345,-1.2175 7.8281,4.4431 4.3364,7.9348 -2.6457,2.6456 -7.2541,1.3897 -8.5893,-2.3408 -0.1866,-0.5214 -8.8309,-3.213 -19.2095,-5.9814 -22.7964,-6.0808 -22.758,-6.0876 -27.2415,4.8445 -1.99394,4.8619 -3.41984,7.0436 -4.60491,7.0458 -1.48583,0 -1.26982,-1.0561 1.60683,-7.8769 z" style={{fill: '#FDFDFD'}} />
            <path id="path4207" d="M 2.7363339e-4,73.472079 C 2.7363339e-4,3.5508988 -0.13190637,5.3040488 5.4139736,1.6702388 7.7286136,0.15362884 23.016624,0.02173884 196.50027,0.02173884 c 173.4836,0 188.7717,0.13189 191.0863,1.64849996 5.5459,3.63381 5.4137,1.88066 5.4137,71.8018402 v 64.549661 h -10 -10 v -59.000001 -59 h -176.5 -176.499996 v 59 59.000001 h -10 H 2.7363339e-4 Z" style={{fill: '#FDFDFD'}} />
            <path id="path3941" d="m 99.031874,53.394179 c -0.0174,-0.62015 0.61447,-1.66374 1.404116,-2.31909 2.46502,-2.04579 2.82757,-6.52716 0.86564,-10.69968 -3.798646,-8.07872 -16.567896,-8.29863 -20.536146,-0.35367 -1.65913,3.3218 -1.72354,5.98868 -0.25361,10.5 0.64259,1.97212 0.62962,1.97294 -0.92996,0.0589 -3.60114,-4.41965 -0.48992,-14.46534 5.16882,-16.68935 4.02758,-1.58293 9.37521,-1.37301 13.01857,0.51104 6.315446,3.26585 8.257866,12.20399 3.762566,17.31368 -1.35762,1.54317 -2.482616,2.29836 -2.499996,1.6782 z" style={{fill: '#FDFDFD', fillOpacity: 1}} />
            </svg>
        </div>
    ); 
};  
const MainApp = (state) => { 

    ////
    //console.log( state.cardAppSelected ); 
    // Return the HTML
    return Apps.filter(function (el, index) {
        return index == state.cardAppSelected;
    })[0].MainAppHTML; 

};
const AppHeader = (state) => {   
    // Return the HTML
    return <Title2 className="d-flex justify-content-center text-center w-100" id="AppHeader">{Apps.filter(function (el, index) {
        return index == state.cardAppSelected;
    })[0].header}</Title2>;  
}; 
const AppHeaderMobile = (state) => {    
    // Return the HTML
    return <Subtitle1 className="d-flex justify-content-center text-center w-100" id="AppHeaderMobile">{Apps.filter(function (el, index) {
        return index == state.cardAppSelected;
    })[0].header}</Subtitle1>; 
}; 


const AppDescription = (state) => {  
    // Return the HTML
    return <Text id="AppDescription" size={500}>{Apps.filter(function (el, index) {
        return index == state.cardAppSelected;
    })[0].description}</Text>;
};
const AppCompany = (state) => {  
    // Return the HTML
    return <Text className="d-flex justify-content-center text-center w-100" size={400}>{Apps.filter(function (el, index) {
        return index == state.cardAppSelected;
    })[0].company}</Text>;
};
const AppIcon = (state) => {  
    // Return the HTML
     
    //
    var img = Apps.filter(function (el, index) {
        return index == state.cardAppSelected;
    })[0].image;

    return <img
        src={img.src}
        alt={img.alt}
    />;
};



// React Component
export class RBILLC extends React.Component {
      
    //Init State Object
    state = {
        cardAppSelected: 0,  
    }


    //callback method
    myCallback = (dataFromChild) => {
        //use dataFromChild 
        this.state['cardAppSelected'] = dataFromChild; 
        this.forceUpdate();
    }

    // Render React Component
    render() {

        let styles = useStyles();
        //console.log({ styles });
         
        //Add the sample apps by JSON...
        // Load the sample apps by JSON...
        // ADd the LOGO
        //Banner Formatting
        //Card Formatting
        // Mobile Formatting
         
        return (

            <ThemeProvider
                breakpoints={['xxxxl', 'xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
                minBreakpoint="xs"
            >
                <div>
                    {/*<div id="Banner">*/}
                    {/*    <img style={{ width: "100vw", transform: "translate(0,-75px)" }} alt="" src="https://images.squarespace-cdn.com/content/v1/5b608252ec4eb7a5e69c9d6b/1536453394975-NA7E7U714P60XFMYW6KV/IMG_20180220_173953.jpg?format=2500w"></img>*/}
                    {/*</div>*/}

                    <div id="Content" className="d-flex flex-column align-items-between" style={{
                        position: "absolute", width: "100vw",
                        //height: "calc(-30px + 100vh)",
                        //top: "30px", 
                        top: "0px",
                        color: "#fdfdfd"
                    }}>

                        <div className="d-flex">
                            <div id="banner1" className="d-flex align-items-center"
                                style={{ height: "100px", "borderTop": "5px solid #FFE78A" }}>

                                <Logo width="42" height="42" />
                                <Display id="display" style={styles.display4} >Rothenberg Industries, LLC</Display>
                                {/*    <p>Learn about <a href="#anchor-services">us below!</a>.</p>*/}
                            </div>

                            <svg className="ml-2"
                                width="21.17235mm"
                                height="18.518766mm"
                                viewBox="0 0 21.17235 18.518766"
                                version="1.1">
                                <g transform="translate(-120.05985,-265.18639)">
                                    <path style={{ "opacity": "1", "fill": "#FFE78A", "fillOpacity": "1.0", "stroke": "none", "strokeWidth": "0", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeMiterlimit": "4", "strokeDasharray": "none", "strokeOpacity": "1", "paintOrder": "markers stroke fill" }}
                                        d="M 0,0 V 5 H 1.9003906 L 76.138672,69.992188 h 3.882812 v -5 h -2 L 3.7792969,0 Z"
                                        transform="matrix(0.26458333,0,0,0.26458333,120.05985,265.18639)"
                                    />
                                </g>
                            </svg>

                            <div id="buttonContainer" className="d-flex justify-content-end align-items-center mr-1"
                            style={{  "height": "70px", "borderBottom": "5px solid #FFE78A" }}>

                            <Button id="quote" size="large" appearance="" icon={<CalendarMail16Regular />}>
                                Request a Quote!
                            </Button>
                        </div>

                    </div>

                    <Container id="container" style={styles.container}>

                            <Card id="card1" style={styles.card1}>
                                    <CardHeader 
                                        header={
                                            <Body1>
                                                <Title1>CASE STUDIES</Title1>
                                            </Body1>
                                        }
                                        description={<Caption1>15 Projects... Click to preview</Caption1>}
                                    />
                                <div style={styles.grid} role="list">



                                    {/*pass the callback method to the child when it's created.*/}
                                    < CardsCaseStudy cardAppSelected={this.state.cardAppSelected} callbackFromParent={this.myCallback} />

                                    </div>
                                </Card>

                            <Card id="card2" style={styles.containerPreview} size="small">
                                <CardHeader
                                    image={
                                        <AppIcon cardAppSelected={this.state.cardAppSelected} />
                                    }
                                    header={
                                        //<Body1 className="d-flex justify-content-center text-center w-100" >
                                        <div>
                                            <AppHeader cardAppSelected={this.state.cardAppSelected} />
                                            <AppHeaderMobile cardAppSelected={this.state.cardAppSelected} /> 
                                        </div>
                             //           </Body1>
                                    }
                                    description={
                                        <AppCompany cardAppSelected={this.state.cardAppSelected} />
                                    }
                                />

                                <CardPreview>
                                    <Card style={styles.cardPreview} appearance='filled' id="MainApp">

                                        <CardPreview className="h-100">

                                            {/*Render HERE*/}
                                            <MainApp cardAppSelected={this.state.cardAppSelected} />

                                        </CardPreview>

                                    </Card>
                                </CardPreview>
                                <AppDescription cardAppSelected={this.state.cardAppSelected} /> 

                                <CardFooter id="CardFooter">
                                    <Button icon={<ArrowReplyRegular fontSize={16} />}>Reply</Button>
                                    <Button icon={<ShareRegular fontSize={16} />}>Share</Button>
                                </CardFooter>
                            </Card>

                            <Card id="card3" style={styles.containerListMobile}>
                                <div style={styles.gridMobile} role="list">
                                    {/*pass the callback method to the child when it's created.*/}
                                    <CardsCaseStudyMobile cardAppSelected={this.state.cardAppSelected} callbackFromParent={this.myCallback} />
                                </div>
                            </Card>

                        </Container>


                    <footer className="border-top footer text-muted" >
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "50px", color: '#fdfdfd' }}>
                            <p>&copy; 2023 - Rothenberg Industries, LLC</p> 
                        </div>
                    </footer>
                </div>
                </div>
            </ThemeProvider>
        )
    }
}



 